import {useState, useEffect, useMemo} from 'react';

import styled from 'styled-components';
import config from '../../../config';
import {useReport} from '../../../contexts/ReportContext';
import BarGraph from '../../organisms/BarGraph';
import DBDPullDown from '../../atoms/DBDPullDown';
import LabelWithInfo from '../../atoms/LabelWithInfo';
import SelectModal, {SelectedLabel} from '../../organisms/SelectModal';

import moment from 'moment';

const GraphWrap = styled.div`
  position: relative;
`;

const GraphSelectUIWrap = styled.div`
  position: absolute;
  right: 20px;
  top: 70px;
  display: flex;
  gap: 20px;
  @media ${config.layout.wide} {
    top: 20px;
  }
`;

const YearMonthLabel = styled.div`
  display: none;
  @media ${config.layout.wide} {
    display: block;
    position: absolute;
    top: 63px;
    left: 20px;
    font-size: 14px;
    font-weight: bold;
  }
`;

function DataGraph({type, roomID}) {
  const report = useReport();

  let values = [];
  console.log(type, roomID);
  if (report.state.data) {
    const query = report.state.fetched_query;

    const lastDay = parseInt(
        moment.utc(`${query.year}-${(query.month + '').padStart(2, '0')}-01`).
            add(1, 'month').
            add(-1, 'day').
            format('D'),
        10,
    );

    const rooms = report.state.data.room_graphs[type] || [];
    const room =
        rooms.find((room) => room.id == roomID) || null;
    const data = (room && room.values) || [];
    const dayMap = new Map();
    data.forEach((row) => {
      dayMap.set(row.date, row);
    });

    let m = moment.utc(
        `${query.year}-${(query.month + '').padStart(2, '0')}-01`,
    );
    for (let i = 1; i <= lastDay; i++) {
      const dt = m.format('YYYY-MM-DD');
      let row = dayMap.get(dt);
      values.push({
        date: m.toDate(),
        value: (row && row.value) || 0,
        na: !row,
      });
      m.add(1, 'day');
    }
  }

  return (
      <div>
        <BarGraph values={values} unit={type}/>
      </div>
  );
}

export default function VenueReportGraph() {
  const report = useReport();
  const [type, setType] = useState('tracks');
  const [roomID, setRoomID] = useState(0);
  const [typeModalIsOpen, setTypeModalIsOpen] = useState(false);
  const [roomModalIsOpen, setRoomModalIsOpen] = useState(false);

  const onClickType = () => {
    setTypeModalIsOpen(true);
  };

  const closeTypeModal = () => {
    setTypeModalIsOpen(false);
  };

  const types = [
    {
      value: 'tracks',
      label: 'Tracks',
    },
    {
      value: 'hours',
      label: 'Hours',
    },
  ];

  const typeItemSelect = (index) => {
    setTypeModalIsOpen(false);
    setType(types[index].value);
  };

  const rooms = (report.state.data &&
          report.state.data.room_graphs &&
          report.state.data.room_graphs.rooms) ||
      [];

  //console.log(rooms);
  const onClickRoom = () => {
    setRoomModalIsOpen(true);
  };

  const closeRoomModal = () => {
    setRoomModalIsOpen(false);
  };

  const roomItemSelect = (index) => {
    setRoomID(rooms[index].id);
  };

  useEffect(() => {
    setRoomID(0);
  }, [report.state.query]);

  const yearMonthStr = useMemo(() => {
    let year = report.state.query?.year || 0;
    let month = report.state.query?.month || 0;

    if (!month) {
      return '';
    }
    let date = new Date();
    date.setFullYear(year);
    date.setDate(10);
    date.setMonth(month - 1);
    return moment(date).format('MMM YYYY').toUpperCase();
  }, [report.state.query]);

  return (
      <>
        <GraphWrap>
          <DataGraph type={type} roomID={roomID}/>
          <GraphSelectUIWrap>

            <SelectedLabel onClick={onClickRoom}
                           style={{
                             width: 140,
                           }}
            >{rooms.find(t => t.id == roomID)?.name ||
                ''}</SelectedLabel>
            <SelectModal
                title="Room/Floor"
                candidates={rooms.map((room) => room.name)}
                selectedIndex={rooms.reduce((p, c, i) => {
                  if (p >= 0) {
                    return p;
                  }
                  if (roomID == c.id) {
                    return i;
                  }
                  return p;
                }, -1)}
                closeModal={closeRoomModal}
                modalIsOpen={roomModalIsOpen}
                itemSelect={roomItemSelect}
            />

            <SelectedLabel onClick={onClickType}
                           style={{
                             width: 120,
                           }}
            >{types.find(t => t.value == type).label}</SelectedLabel>
            <SelectModal
                title="Type"
                candidates={types.map(t => t.label)}
                selectedIndex={types.reduce((p, c, i) => {
                  if (p >= 0) {
                    return p;
                  }
                  if (type == c.value) {
                    return i;
                  }
                  return p;
                }, -1)}
                closeModal={closeTypeModal}
                modalIsOpen={typeModalIsOpen}
                itemSelect={typeItemSelect}
            />

          </GraphSelectUIWrap>
          <LabelWithInfo
              text={'Played (Room/Floor)'}
              labelclassname={'stats-name-label'}
              style={{
                position: 'absolute',
                left: 20,
                top: 20,
              }}
          >
            <div>
              You can see the activity chart in the selected period. Change the
              data source from the pulldown menu on the right top of the graph.
            </div>
          </LabelWithInfo>
          <YearMonthLabel>{yearMonthStr}</YearMonthLabel>
        </GraphWrap>
      </>
  );
}
